import React from 'react'

const PageTitle = ({title}) => {
  return (
    <>
    <div className="user__page__content_inner user__page__content_title">
    <h2>{title}</h2>
    </div>
    
    </>
  )
}

export default PageTitle